import React, { useState, useEffect } from "react";
import Slider from "react-slick";

export default function WeUse() {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
   const [activeId, setActiveId] = useState(0);
  let slider1, slider2;

  // Static "We Use" content
  const weUseContents = [
    {
      title: "Dedicated Gaming Developer",
      description:
        "Hire us to benefit from our dedicated game app developers and guarantee that you will have the best version of your game developed and delivered to you."
    },
    {
      title: "Unity Game Engine",
      description:
        "Our game development services use the best game development platform, Unity. Ensuring excellent games are developed."
    },
    {
      title: "2D & 3D Games",
      description:
        "Whether you need a 2D or complex 3D game, our effective yet small game development team is ready to develop a solution."
    },
    {
      title: "Cross-Platform Games",
      description:
        "Unity offers the ability to create platform-independent games that run seamlessly on any mobile operating system."
    }
  ];

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  }, [slider1, slider2]);

  return (
    <section className="released-games-area gray-bg pt-40 pb-40">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-10">
            <div className="section-title title-style-three text-center mb-20">
              <h2>
                We <span>Use</span>
              </h2>
              <p>
                Our technology stack and expertise ensure top-notch game development across
                platforms with reliable performance and engaging experiences.
              </p>
            </div>
          </div>
        </div>

        <div className="row align-items-center">
          {/* Main slider */}
          <div className="col-xl-8 col-lg-12">
            <Slider
              className="released-game-active"
              asNavFor={nav2}
              ref={(slider) => (slider1 = slider)}
              arrows={false}
              autoplay={true}
                afterChange={(index) => setActiveId(index)}
            >
              {weUseContents.map((item, i) => (
                <div key={i} className="released-game-carousel">
                  <div className="released-game-item">
                    <div className="released-game-item-bg" />
                    <div className="released-game-content">
                      <h4>{item.title}</h4>
                      <p>{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          <div className="col-xl-4 col-lg-12">
            <Slider
              className="released-game-nav"
              asNavFor={nav1}
              swipeToSlide={true}
              focusOnSelect={true}
              ref={(slider) => (slider2 = slider)}
              slidesToShow={3}
              vertical={true}
              arrows={false}
              autoplay={true}
                afterChange={(index) => setActiveId(index)}
            >
              {weUseContents.map((item, i) => (
                <div key={i} 
                 onClick={() => setActiveId(i)}
  className={`released-game-nav-item p-4 text-white bg-white ${
    activeId === i ? "bg-danger-dark" : ""
  }`}>
                  <h5 className="text-black">{item.title}</h5>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
}
